import { Description, Email, GroupAdd, Logout } from '@mui/icons-material'
import Amil from 'components/svg/amil'
import Bradesco from 'components/svg/bradesco'
import ConveniaIcon from 'components/svg/convenia-icon'
import DocumentIcon from 'components/svg/document'
import ESocialIcon from 'components/svg/e-social-icon'
import GoogleDriveIcon from 'components/svg/google-drive-icon'
import HapVida from 'components/svg/hapvida'
import Icatu from 'components/svg/icatu'
import Mag from 'components/svg/mag'
import MapFre from 'components/svg/mapfre'
import OneDriveIcon from 'components/svg/one-drive-icon'
import ProtheusIcon from 'components/svg/protheus-icon'
import Prudential from 'components/svg/prudential'
import QBemIcon from 'components/svg/qbem-icon'
import ServiceNowIcon from 'components/svg/service-now-icon'
import SlackIcon from 'components/svg/slack-icon'
import SnowFlakeIcon from 'components/svg/snowflake'
import SulAmerica from 'components/svg/sul-america'
import WhatsApp from 'components/svg/whatsApp'
import Zurich from 'components/svg/zurich'
import UnimedSantos from 'components/svg/unimed-santos'

const IconObject = {
  'e-social': <ESocialIcon />,
  email: <Email color='primary' />,
  'e-mail': <Email color='primary' />,
  googledrive: <GoogleDriveIcon />,
  servicenow: <ServiceNowIcon />,
  protheus: <ProtheusIcon />,
  qbem: <QBemIcon />,
  onedrive: <OneDriveIcon />,
  'posiçãocadastral-uploaddearquivos': (
    <Logout
      fontSize='small'
      sx={{ transform: 'rotate(270deg)' }}
    />
  ),
  posiçãocadastral: (
    <Logout
      fontSize='small'
      sx={{ transform: 'rotate(270deg)' }}
    />
  ),
  formatodearquivos: <Description fontSize='small' />,
  snowflake: <SnowFlakeIcon />,
  aprovação: <DocumentIcon />,
  rejeitados: <DocumentIcon />,
  exceções: <DocumentIcon />,
  adesões: <DocumentIcon />,
  multiplaescolha: <DocumentIcon />,
  editarpessoasjurídicas: (
    <GroupAdd
      fontSize='medium'
      color='success'
    />
  ),
  slack: <SlackIcon />,
  convenia: <ConveniaIcon />,
  sulamerica: <SulAmerica />,
  bradeso: <Bradesco />,
  amil: (
    <Amil
      width={32}
      height={32}
    />
  ),
  hapvida: (
    <HapVida
      width={32}
      height={32}
    />
  ),
  icatu: (
    <Icatu
      width={32}
      height={32}
    />
  ),
  mapfre: (
    <MapFre
      width={32}
      height={32}
    />
  ),
  zurich: (
    <Zurich
      width={32}
      height={32}
    />
  ),
  prudential: (
    <Prudential
      width={64}
      height={32}
    />
  ),
  mag: <Mag />,
  whatsapp: (
    <WhatsApp
      width={32}
      height={32}
    />
  ),
  unimedsantos: <UnimedSantos />
}

export const getFormmatted = (text: string): string => {
  if (text == undefined || text == null) {
    return ''
  }

  const splitText = text.split(' - ')
  text = splitText[0].trim()
  text = text.toLocaleLowerCase()
  text = text.replace(/\s+/g, '')
  text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

  return text
}

export const getIcon = (text: string): any => {
  text = getFormmatted(text)

  let icon = null

  Object.keys(IconObject).forEach((key, i) => {
    if (key === text) {
      icon = Object.values(IconObject)[i]
    }
  })

  if (icon == null) {
    icon = <DocumentIcon />
  }

  return icon
}
